var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('u-tags-group',[_vm._l((_vm.groupedLocations),function(location){return _c('b-tag',{key:location.id,attrs:{"type":"is-info"}},[_vm._v("\n    "+_vm._s(("" + (location.label) + (location.regions || location.postCodes
          ? ("(" + (location.regions
                ? _vm.$tc("_plurals.regions", location.regions)
                : "") + (location.postCodes
                ? ("" + (location.regions ? ", " : "") + (_vm.$tc(
                    "_plurals.postcodes",
                    location.postCodes
                  )))
                : "") + ")")
          : "")))+"\n  ")])}),_vm._v(" "),(_vm.groupedLocations.length !== _vm.allGroupedLocations.length)?[_c('small',{staticClass:"has-text-grey is-size-8"},[_vm._v(_vm._s(_vm.$tc("_plurals.plus_other_locations", _vm.allGroupedLocations.length - _vm.limit)))])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }